import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { hDeepCopy } from '@/utils/helpers';
import sRouter from '@/services/sRouter';
import sPackage from '@/services/sPackage';
import { getMenuScheme, visibilityDependOnAcl } from '@/components/Panel/MenuCommon';


// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PackageUsage',

  data() {
    return {
      icons: {
        pieChart: require("@/assets/pie-chart.svg"),
        arrow: require("@/assets/arrow-up.svg"),
      },

    }
  },
  computed: {
    ...mapGetters(['servicesList', 'getUsageLoading', 'packageUsage', 'acl']),
    startDate() {
      const names = {
        0: "stycznia",
        1: "lutego",
        2: "marca",
        3: "kwietnia",
        4: "maja",
        5: "czerwca",
        6: "lipca",
        7: "sierpnia",
        8: "września",
        9: "października",
        10: "listopada",
        11: "grudnia"
      }
      let currentDate = new Date();
      return "1 " + names[currentDate.getMonth()];
    },
    activePackage() {
      const packagesList = hDeepCopy(this.servicesList).filter(obj => (obj.feature_type === 'Promotion' || obj.feature_type === 'Package') && obj.date !== null);
      return packagesList.sort((a, b) => 
        Math.sign(b.more_than_one_feature - a.more_than_one_feature) * 8 + 
        Math.sign(moment(b.date) - moment(a.date)) * 4 + 
        Math.sign(b.usage_label.length - a.usage_label.length) * 2 + 
        Math.sign(a.usage_label.localeCompare(b.usage_label))
        )[0];
    },
    activePackageLabel() {
      return sPackage.getPackageLabel(this.activePackage);
    },
    checkIfUsageInStore() {
      return !Object.keys(this.packageUsage).length;
    },
    packageLabel() {
      return sPackage.getSizeLabels(this.activePackage);
    },
    packageSize() {
      return sPackage.getSizeValues(this.activePackage);
    },
    packageBarWidth() {
      return sPackage.getPackageUsagePercentage(this.activePackage, this.packageUsage);
    },
    showAddBtn() {
      return visibilityDependOnAcl(this, getMenuScheme()[3]);
    }
  },
  mounted() {
    this.getServicesList();
  },
  methods: {
    ...mapActions(['getServicesList', 'getPackageUsage', 'clearPackageUsage', 'selectCategory']),
    async checkUsage() {
      const param = {
        feature: this.activePackage.uuid,
      };
      await this.getPackageUsage(param);
    },
    collapseExtended() {
      this.clearPackageUsage();
    },
    changeUrl(pathObject) {
      sRouter.changeUrl(pathObject, this.$router);
      this.selectCategory('Internet krajowy');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/PackageUsage/component.js